module.exports = __webpack_public_path__ + "static/media/loading_wheel.a21746f5.gif";